import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import Login from "./pages/Login";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutFailure from "./pages/CheckoutFailure";
import "./App.css";
import GoogleCallback from "./pages/GoogleCallback";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/login" element={<Login />} />
      <Route path="/success" element={<CheckoutSuccess />} />
      <Route path="/failure" element={<CheckoutFailure />} />
      <Route path="/google/callback" element={<GoogleCallback />} />
    </Routes>
  </BrowserRouter>
);
